import { Component } from '@angular/core';

@Component({
    standalone: false,
    selector: 'app-root',
  templateUrl: './bootstrap.component.html',
  styleUrl: './bootstrap.component.scss'
})
export class BootstrapComponent {

}
